import React from 'react';
import { AuthPermissions } from 'skipify-types';
import { useMerchant } from '../../contexts/MerchantContext';

type CanAccessProps = {
  children: React.JSX.Element;
  permissions: (typeof AuthPermissions)[keyof typeof AuthPermissions][];
};

const CanAccess = ({ children, permissions }: CanAccessProps): React.JSX.Element | null => {
  const { canAccess: userCanAccess } = useMerchant();

  if (permissions.some((permission) => userCanAccess(permission))) {
    return children;
  }

  return null;
};

export default CanAccess;
